import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaBook, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import { Avatar } from '@mui/material';
import { toast } from 'react-toastify';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const ADMIN_EMAIL = 'ramonsaint23@gmail.com';

const AppSidebar = ({ user }) => {
  const [isToggle, setIsToggle] = useState(false);
  const navigate = useNavigate();
  const isAdmin = user?.email === ADMIN_EMAIL;

  const handleLogout = async () => {
    await signOut(auth);
    toast.success('Logged out successfully!');
    navigate('/');
  };

  return (
    <div className="flex h-screen">
      <div
        className={`fixed inset-y-0 left-0 z-50 transition-all duration-300 ease-in-out bg-gray-800 text-white 
        md:translate-x-0 md:static md:w-64 ${isToggle ? "w-44" : "w-20"}`}
      >
        <div className="flex flex-col h-full">
          {/* Top header */}
          <div className="flex items-center justify-between p-4 bg-gray-900">
            <h1 className={`text-lg font-bold ${isToggle ? "block" : "hidden"}`}>PoemXtra</h1>
            <button onClick={() => setIsToggle(!isToggle)} className="text-white md:hidden block">
              {isToggle ? <FaTimes /> : <FaBars />}
            </button>
          </div>

          {/* Avatar */}
          <div className="flex flex-col items-center py-6">
            <Avatar alt={user?.name} src={user?.avatarUrl} sx={{ width: 60, height: 60 }} />
            <div className={`mt-3 text-base font-semibold ${isToggle ? "block" : "hidden"}`}>{user?.name}</div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 space-y-2">
            <Link
              to="/dashboard"
              className="flex items-center p-2 text-sm font-medium text-white rounded-lg hover:bg-gray-700"
            >
              <FaTachometerAlt className="mr-4" />
              <span className={`${isToggle ? "block" : "hidden"} md:block`}>Dashboard</span>
            </Link>

            <Link
              to="/my-content"
              className="flex items-center p-2 text-sm font-medium text-white rounded-lg hover:bg-gray-700"
            >
              <FaBook className="mr-4" />
              <span className={`${isToggle ? "block" : "hidden"} md:block`}>My Content</span>
            </Link>

            {isAdmin && (
              <Link
                to="/approve-poems"
                className="flex items-center p-2 text-sm font-medium text-white rounded-lg hover:bg-green-700 bg-green-800"
              >
                <FaBook className="mr-4" />
                <span className={`${isToggle ? "block" : "hidden"} md:block`}>Approve Poems</span>
              </Link>
            )}

           
          </nav>

          {/* Logout */}
          <div className="mt-auto p-4">
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center p-2 bg-red-600 hover:bg-red-700 rounded"
            >
              <FaSignOutAlt />
              <span className={`ml-2 ${isToggle ? "block" : "hidden"} md:block`}>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSidebar;
